/** Single-line label: legal name, else trade/DBA, else fallback. */
export function pickCompanyDisplayName(
  legalName: string | null | undefined,
  tradeName?: string | null,
  fallback = "Company Name",
): string {
  const legal = (legalName ?? "").trim();
  const trade = (tradeName ?? "").trim();
  return legal || trade || fallback;
}

/** Display label for company headers: legal name with trade/DBA in parentheses when distinct. */
export function formatCompanyDisplayName(
  legalName: string | null | undefined,
  tradeName?: string | null,
  fallback = "Company Name",
): string {
  const legal = (legalName ?? "").trim() || fallback;
  const trade = (tradeName ?? "").trim();
  if (!trade || trade.toLowerCase() === legal.toLowerCase()) return legal;
  return `${legal} (TradeName : ${trade})`;
}
